<script>

export let message;
const GATrackingID = 'UA-8727745-1';
const GAUrlPath = '/automated-sample-management/q20configurator/';

//track pageview with Google
gtag('config', GATrackingID, {
  'title' : 'Region Unavailable',
  'page_location' : 'error',
  'page' : GAUrlPath + 'error'
});

</script>


<!-- STYLES START -->
<style>
  
    .button {
      font-family: Camphor W01 Bold;
      text-transform: uppercase;
    }
  
    .button.blue {
      background: #1F74B8;
    }
  
    .button.transparent {
      color: #1F74B8;
    }
  
    .button:focus {
      @apply border-blue-500 !important;
      outline: none;
      box-shadow: 0 0 5px rgba(81, 203, 238, 1);
    }
  
    .button:hover {
      @apply border-gray-500 transition duration-100 ease-in;
    }
  
    .active {
      @apply border-blue-500;
    }
  
    @media (min-width: 1024px) { 
      .bg {
        background-image: url(/img/purchaseOptions--hero@3x.jpg);
        height: 100%;
        width: 100%;
        background-size: cover;
        background-position: center;
        animation: zoomin 2s ease-out;
        animation-fill-mode: forwards;
      }
      
      @keyframes zoomin {
        0% {
          opacity: 0;
          transform: scale(1.1);
        }
        100% {
          opacity: 1;
          transform: scale(1);
        }
      }
  
      .title {
        font-family: Camphor W01 Bold;
      }
  
      header {
        background: linear-gradient(177.21deg, #005397 0.77%, #00467f 76.64%);
      }
    }
  
    .nav {
      background: linear-gradient(190.51deg, rgba(54, 137, 204, 0.95) 46.75%, rgba(31, 116, 184, 0.95) 82.08%);
    }
  </style>
  <!-- STYLES END -->
  
  
  
  <!-- HTML START -->
  <div class="lg:h-full lg:overflow-y-hidden">
      <div class="relative z-10 lg:h-full lg:overflow-y-scroll">
      <div class="flex flex-col lg:flex-row lg:flex-no-wrap lg:w-100 text-lg lg:min-h-full">
        <div class="lg:flex-1">
  
          <div class="relative lg:h-full lg:w-full overflow-hidden">
            <div class="bg absolute top-0 left-0"></div>
          </div>
  
          <div class="relative lg:hidden">
            <img class="w-full md:w-1/2 md:m-auto md:mt-10" src="/img/baseSystem--hero.jpg" alt="Verso Q20 rendering">
          </div>
        
        </div>
        <div class="flex-1 flex items-center">
          <div class="bg-white text-center px-10 mb-12 lg:mx-auto max-w-screen-sm ">  
            <h2 class="title p-8 pb-0 text-3xl text-gray-800">Page Error</h2>
            <p>There was an error loading this page. Details: "<span class="text-red-600">{message}</span>"</p>
            <p>
                <a href="mailto:&#109;&#97;&#105;&#108;&#116;&#111;&#58;%77%65%62%73%69%74%65%73%75%70%70%6F%72%74%40%68%61%6D%69%6C%74%6F%6E%63%6F%6D%70%61%6E%79%2E%63%6F%6D" class="inline-block button blue rounded-full border-2 border-white text-white w-2/3 px-14 py-6 mt-6" style="font-family: Camphor W01 Bold;">Report this issue</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- HTML END -->